import React from 'react';
import MainCard from './components/MainCard';
import './styles/App.css';

function App() {
  return (
    <div className="App">
      <MainCard />
    </div>
  );
}

export default App;